<template>
  <div>
    <div id="searcher">
      <div class="wrapper">
        <div class="search-box">
          <div class="search-text">
            <h2>轻研智库 研判未来</h2>
          </div>
          <el-input
            placeholder="请输入检索词"
            v-model="searchInput"
            class="search-input"
            @keyup.enter.native="handleSearch"
            clearable
          >
            <el-button
              class="search-input_button"
              slot="append"
              @click="handleSearch"
              >检索</el-button
            >
          </el-input>
        </div>
      </div>
    </div>
    <div id="body">
      <div class="wrapper">
        <div
          :class="
            searchFilterShow ? 'search-filter filter-show' : 'search-filter'
          "
        >
          <div class="filter-op" @click="searchFilterShow = !searchFilterShow">
            检索筛选 <i class="el-icon-arrow-up"></i>
          </div>
          <el-form label-width="8.0em">
            <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-class.png" alt="" />行业分类
              </div>
              <el-checkbox-group
                v-model="filterClass"
                @change="handleIndustryChange"
              >
                <el-checkbox
                  v-for="(item, index) in aggregations.industry_count"
                  :key="index"
                  :label="item.key"
                >
                  <!-- {{ item.key }}({{ item.count }}) -->
                  {{ item.key }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-type.png" alt="" />数据类型
              </div>
              <el-checkbox-group
                v-model="filterType"
                @change="handleTypeChange"
              >
                <el-checkbox
                  v-for="(item, index) in aggregations.type_count"
                  :key="index"
                  :label="item.key"
                >
                  <!-- {{ item.key }}({{ item.count }}) -->
                  {{ item.key }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-time.png" alt="" />发布时间
              </div>
              <el-radio-group v-model="filterTime" @change="handleTimeChange">
                <el-radio border :label="0">近一月</el-radio>
                <el-radio border :label="1">近三月</el-radio>
                <el-radio border :label="2">近半年</el-radio>
                <el-radio border :label="3">
                  <el-date-picker
                    v-model="filterTimeRange"
                    type="daterange"
                    size="small"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="datePickerChange"
                    unlink-panels
                  >
                  </el-date-picker>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item>
              <div slot="label">
                <img src="~@/assets/images/icon-f-more.png" alt="" />更多筛选
              </div>
              <div class="item-block">
                <span class="inner-label">发布机构：</span>
                <el-input
                  placeholder="请输入检索词"
                  v-model="filterInputInstitution"
                  size="small"
                  class="filter-input"
                  @keyup.enter.native="handleInstitutionSearch"
                >
                  <el-button
                    slot="append"
                    size="small"
                    @click="handleInstitutionSearch"
                    >检索</el-button
                  >
                </el-input>
              </div>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="search-top">
          <div class="search-sort">
            <el-form label-width="6em">
              <el-form-item>
                <div slot="label">综合排序</div>
                <el-select
                  v-model="searchSort"
                  size="small"
                  @change="handleSortChange"
                >
                  <el-option :value="0" label="时间"></el-option>
                  <el-option :value="1" label="相关度"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="search-top-page" v-if="showPagination">
            <el-pagination
              :current-page="pageIndex"
              :page-size="pageSize"
              layout="prev,pager,next"
              :total="total > 10000 ? 10000 : total"
              @current-change="handleCurrentPageChange"
            >
            </el-pagination>
          </div>
          <div class="search-result">
            找到
            <span>{{ total > 10000 ? "10000+" : total }}</span>
            条结果
            <!-- （用时0.03秒） -->
          </div>
        </div>
        <div
          class="search-op"
          v-if="
            (filterClass && filterClass.length > 0) ||
            (filterType && filterType.length > 0) ||
            (filterTime != null && filterTime != undefined) ||
            filterInput
          "
        >
          <div class="search-filter-item">
            <template v-if="filterClass && filterClass.length > 0">
              <span>行业分类：</span>
              <el-tag
                closable
                v-for="(item, index) in filterClass"
                :key="'filterClass' + index"
                @close="handleIndustryChange(item, 'remove')"
              >
                <span>{{ item }}</span>
              </el-tag>
            </template>

            <template v-if="filterType && filterType.length > 0">
              <span>数据类型：</span>
              <el-tag
                closable
                v-for="(item, index) in filterType"
                :key="'filterType' + index"
                @close="handleTypeChange(item, 'remove')"
              >
                <span>{{ item }}</span>
              </el-tag>
            </template>

            <template v-if="filterTime != null && filterTime != undefined">
              <span>发布时间：</span>
              <el-tag
                closable
                v-if="filterTime === 0"
                @close="handleTimeRemove"
              >
                <span>近一月</span>
              </el-tag>
              <el-tag
                closable
                v-else-if="filterTime === 1"
                @close="handleTimeRemove"
              >
                <span>近三月</span>
              </el-tag>
              <el-tag
                closable
                v-else-if="filterTime === 2"
                @close="handleTimeRemove"
              >
                <span>近半年</span>
              </el-tag>
              <el-tag closable v-else @close="handleTimeRemove">
                <span>
                  {{ dateFormat(filterTimeRange[0], "date") }}
                  -
                  {{ dateFormat(filterTimeRange[1], "date") }}
                </span>
              </el-tag>
            </template>

            <template v-if="filterInput">
              <span>发布机构：</span>
              <el-tag
                closable
                @close="
                  filterInput = '';
                  filterInputInstitution = '';
                  changeQueryParams(true);
                "
              >
                <span>{{ filterInput }}</span>
              </el-tag>
            </template>

            <el-button icon="el-icon-delete" size="small" @click="clearFilter"
              >清空筛选</el-button
            >
          </div>
        </div>
        <div class="search-result-list">
          <div class="data-list">
            <el-skeleton :loading="loading" :count="8" animated>
              <template slot="template">
                <dl>
                  <dt>
                    <el-skeleton-item variant="h2" />
                  </dt>
                  <dd class="pic">
                    <el-skeleton-item variant="image" />
                  </dd>
                  <dd class="info">
                    <span class="t">
                      <el-skeleton-item
                        variant="text"
                        style="width: 66px"
                      /> </span
                    ><span class="o">
                      <el-skeleton-item variant="text" style="width: 66px" />
                    </span>
                  </dd>
                  <dd class="bottom">
                    <el-skeleton-item variant="text" style="width: 80px" />
                    <el-skeleton-item variant="button" style="width: 80px" />
                  </dd>
                </dl>
              </template>
              <template>
                <dl v-for="(item, index) in records" :key="index">
                  <dt v-if="item.picTitle">
                    <span
                      v-html="
                        item.picTitle.replace(
                          /[图表]+?[\d-]{0,6}[:：\s\.]+/g,
                          ''
                        )
                      "
                    ></span>
                    <span v-if="showNewTab(item.date)" class="status s-new"
                      >上新</span
                    >
                    <!-- <span v-if="showDeepTab(item.pdfTab)" class="status s-deep"
                  >深度</span
                > -->
                  </dt>
                  <dd class="pic">
                    <el-image
                      :src="item.picPath"
                      @click="showImgViewer(index)"
                      lazy
                    >
                      <div slot="error" style="margin-top: -120px">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </dd>
                  <dd class="info">
                    <span class="t" v-if="item.date">{{
                      dateFormat(item.date, "date")
                    }}</span>
                    <span
                      class="o"
                      v-if="item.industry && item.industry.length > 0"
                    >
                      <span
                        v-for="(industry, index) in item.industry"
                        :key="index"
                        v-html="industry"
                      ></span
                    ></span>
                  </dd>
                  <dd class="bottom">
                    <el-tag v-if="item.picType && item.picType.length > 0">
                      <img src="~@/assets/images/icon-tag.png" alt="" />
                      <span
                        v-for="(picType, index) in item.picType"
                        :key="index"
                      >
                        {{ (index > 0 ? "| " : "") + picType }}
                      </span>
                    </el-tag>
                    <template v-if="item.pdfPath">
                      <el-button
                        size="small"
                        @click="viewPath(item.id, item.picPath, item.title)"
                        v-if="
                          item.pdfPath.substring(
                            item.pdfPath.lastIndexOf('.')
                          ) === '.pdf'
                        "
                      >
                        <img
                          src="~@/assets/images/icon-view.png"
                          alt=""
                        />查看原文
                        <!-- <el-link :href="item.pdfPath" target="_blank">
                    <img src="~@/assets/images/icon-view.png" alt="" />查看原文
                  </el-link> -->
                      </el-button>
                      <el-button
                        size="small"
                        @click="
                          handleDownload(
                            item.id,
                            item.title,
                            item.pdfPath.substring(
                              item.pdfPath.lastIndexOf('.')
                            )
                          )
                        "
                        v-else
                      >
                        <img
                          src="~@/assets/images/icon-view.png"
                          alt=""
                        />查看原文
                        <!-- <el-link :href="item.pdfPath" target="_blank">
                    <img src="~@/assets/images/icon-view.png" alt="" />查看原文
                  </el-link> -->
                      </el-button>
                    </template>
                  </dd>
                </dl>

                <div class="no-data" v-if="!records || records.length === 0">
                  <div class="tip">
                    <svg
                      t="1626241932884"
                      class="icon"
                      viewBox="0 0 1428 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="2321"
                      width="60"
                      height="60"
                    >
                      <path
                        d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                        p-id="2322"
                      ></path>
                      <path
                        d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                        p-id="2323"
                      ></path>
                      <path
                        d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                        p-id="2324"
                      ></path>
                      <path
                        d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                        p-id="2325"
                      ></path>
                      <path
                        d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                        p-id="2326"
                      ></path>
                      <path
                        d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                        p-id="2327"
                      ></path>
                    </svg>
                    <div class="text">暂无数据</div>
                  </div>
                </div>
              </template>
            </el-skeleton>

            <!-- <dl class="more">
              <dd>下一页</dd>
            </dl> -->
          </div>
        </div>
        <div class="search-bottom" v-if="showPagination">
          <div class="search-page-total">
            共 {{ total > 10000 ? "10000+" : total }} 条 第 {{ pageIndex }}/{{
              pageCount > 1000 ? "1000+" : pageCount
            }}页
          </div>
          <div class="search-page">
            <el-pagination
              :current-page="pageIndex"
              :page-size="pageSize"
              layout=" prev,pager,next,jumper"
              :total="total > 10000 ? 10000 : total"
              @current-change="handleCurrentPageChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="imgViewerVisible">
      <el-image-viewer
        :on-close="closeImgViewer"
        :url-list="imgList"
        :initialIndex="imgViewerIndex"
        :onSwitch="imgViewerOnSwitch"
      />
      <div class="img-viewer-title">
        <h3 v-html="getReportTitle()"></h3>
      </div>
      <div class="img-viewer-download">
        <span
          class="el-image-viewer__btn el-image-viewer__next"
          @click="downloadImg"
        >
          <i class="el-icon-download"></i>
        </span>
      </div>
    </div> -->

    <el-dialog
      :visible.sync="imgViewerVisible"
      width="1100px"
      class="report-picshow"
      :before-close="closeImgViewer"
    >
      <div class="intro">
        <img class="logo" src="@/assets/images/logo.svg" alt="" />
        <p>
          轻研智库全面覆盖各投资领域，依托海量的宏观策略、行业发展、上市公司等研究报告，采用智能搜索引擎、专业OCR识别、文档结构化解析、自然语言处理等技术，致力于为金融投资人员、企业高管、咨询顾问、行业研究员、市场分析师、市场运营人员等提供便捷、全面的实时、专业的信息检索服务。
        </p>
      </div>

      <div class="picshow">
        <el-carousel
          trigger="click"
          :autoplay="false"
          arrow="always"
          indicator-position="none"
          ref="carousel"
          @change="handleCarouselChange"
        >
          <el-carousel-item v-for="(item, index) in records" :key="index">
            <label
              v-if="item && item.picTitle"
              v-html="
                item.picTitle
                  .replace(/(<([^>]+)>)/gi, '')
                  .replace(/[图表]+?[\d-]{0,6}[:：\s\.]+/g, '')
              "
            >
            </label>
            <el-image :src="item.picPath"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="report-info">
        <div
          class="title"
          v-if="records[imgViewerIndex] && records[imgViewerIndex].title"
          v-html="records[imgViewerIndex].title.replace(/(<([^>]+)>)/gi, '')"
        ></div>
        <div class="info">
          <span
            class="t"
            v-if="records[imgViewerIndex] && records[imgViewerIndex].date"
          >
            <img src="~@/assets/images/icon-time.png" alt="" />
            {{ dateFormat(records[imgViewerIndex].date, "date") }}
          </span>
        </div>
        <div class="bottom">
          <span
            class="type"
            v-if="records[imgViewerIndex] && records[imgViewerIndex].industry"
          >
            {{ records[imgViewerIndex].industry[0] }}
          </span>
          <span class="op">
            <el-button size="small" @click="downloadImg">
              <img src="~@/assets/images/icon-download.png" alt="" />
              下载
            </el-button>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";
import {
  downloadReport,
  downloadDataIntelligenceImg,
  updateLoginUserInfo,
} from "../../util/utils";

export default {
  components: {
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      searchFilterShow: false,
      searchInput: "",
      filterType: [],
      filterClass: [],
      filterTime: null,
      filterTimeRange: [],
      filterInputInstitution: "",
      filterInput: "",
      searchSort: 1,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      pageCount: 0,
      records: [],
      aggregations: {},
      imgViewerVisible: false,
      imgList: [],
      imgViewerIndex: 0,
      loading: false,
      showPagination: false,

      picReport: {},
    };
  },
  created() {
    this.setQueryParams(this.$route.query);

    this.getSearch();
  },
  watch: {
    "$route.query"(newQuery) {
      this.setQueryParams(newQuery);

      this.getSearch();
    },
  },
  mounted() {},
  methods: {
    handleCarouselChange(index, oldIndex) {
      this.imgViewerIndex = index;
    },
    getReportTitle() {
      if (this.records && this.records.length > this.imgViewerIndex) {
        const item = this.records[this.imgViewerIndex];
        if (item && item.title) {
          return item.title;
        }
      }

      return "";
    },
    getCurrentPicTitle() {
      if (this.records && this.records.length > this.imgViewerIndex) {
        const item = this.records[this.imgViewerIndex];
        if (item && item.picTitle) {
          return item.picTitle
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/[图表]+?[\d-]{0,6}[:：\s\.]+/g, "");
        }
      }

      return "";
    },
    viewPath(id, picPath, title) {
      let page = "";
      if (picPath) {
        let filename = picPath.substring(picPath.lastIndexOf("/") + 1);
        page = filename.substring(0, filename.indexOf("_"));
      }
      let url = this.$router.resolve({
        path: "/report/read",
        query: { id: id, type: 1, page: page, title: title },
      });
      window.open(url.href, "_blank");
    },
    showImgViewer(index) {
      document.documentElement.style.overflowY = "hidden";
      this.imgViewerIndex = index;
      this.imgViewerVisible = true;
      setTimeout(() => {
        this.$refs.carousel.setActiveItem(index);
      }, 1);
    },
    closeImgViewer() {
      document.documentElement.style.overflowY = "auto";
      this.imgViewerVisible = false;
    },
    imgViewerOnSwitch(index) {
      this.imgViewerIndex = index;
    },
    downloadImg() {
      if (!this.records || this.records.length === 0) {
        return;
      }

      downloadDataIntelligenceImg(
        this.records[this.imgViewerIndex].id,
        this.getCurrentPicTitle()
      );
    },
    handleDownload(id, title, suffix) {
      downloadReport(1, id, title, suffix);
    },
    showNewTab(date) {
      return (new Date() - new Date(date)) / (60 * 60 * 1000) / 24 < 7;
    },
    showDeepTab(tabs) {
      return (
        tabs && tabs.length > 0 && tabs.some((item) => item === "深度研究")
      );
    },
    dateFormat(cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    setQueryParams(query) {
      if (query.keyword) {
        this.searchInput = query.keyword;
        this.pageIndex = 1;
        this.pageSize = 20;
        this.filterType = [];
        this.filterClass = [];
        this.filterTime = null;
        this.filterTimeRange = [];
        this.searchSort = 1;
        this.filterInput = "";
      } else if (query.params) {
        const params = JSON.parse(query.params) || {};
        this.searchInput = params.keywords[0];
        this.pageIndex = params.pageIndex;
        this.pageSize = 20;
        this.filterType = params.clusters.picType;
        this.filterClass = params.clusters.industry;
        this.filterTime = params.filterTime;
        this.filterTimeRange = [params.startTime, params.endTime];
        this.searchSort = params.sort;
        // this.filterInput = params.filter.institution;
      } else {
        this.searchInput = "";
        this.pageIndex = 1;
        this.pageSize = 20;
        this.filterType = [];
        this.filterClass = [];
        this.filterTime = null;
        this.filterTimeRange = [];
        this.searchSort = 0;
        this.filterInput = "";
      }
    },
    getQueryParams() {
      // if (!this.searchInput) {
      //   this.searchSort = this.searchInput ? 1 : 0;
      // }

      return {
        keywords: this.searchInput ? [this.searchInput] : [],
        highlight: true,
        aggregations: true,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        clusters: {
          picType: this.filterType,
          industry: this.filterClass,
        },
        filterTime: this.filterTime,
        startTime: this.filterTimeRange
          ? this.dateFormat(this.filterTimeRange[0])
          : null,
        endTime: this.filterTimeRange
          ? this.dateFormat(this.filterTimeRange[1])
          : null,
        sort: this.searchSort,
        filter: {
          // institution: this.filterInput,
        },
      };
    },
    changeQueryParams(resetPageIndex) {
      let params = this.getQueryParams();

      if (resetPageIndex) {
        params.pageIndex = 1;
      }

      this.$router.push({
        path: "/qingbao/list",
        query: { params: JSON.stringify(params) },
      });
    },
    handleSearch() {
      if (!this.searchInput) {
        this.$message.warning("请输入检索词");
        return;
      }

      this.$router.push({
        path: "/qingbao/list",
        query: { keyword: this.searchInput },
      });
    },
    getSearch(resetPageIndex) {
      this.loading = true;
      this.showPagination = this.searchInput;

      if (resetPageIndex) {
        this.pageIndex = 1;
      }

      let params = this.getQueryParams();

      axiosRequest(
        "/search/data-intelligence-match",
        params,
        axiosOptions("post", "application/json", "json")
      )
        .then((res) => {
          this.loading = false;

          if (res.data && res.data.code === 200) {
            this.aggregations = res.data.data.aggregations;

            this.pageCount = res.data.data.results.pages;
            this.total = res.data.data.results.total;
            this.records = res.data.data.results.records;
            this.imgList = this.records.map((i) => {
              return i.picPath;
            });
            // this.records = this.records.map((i) => {
            //   this.$set(i, "loading", true);
            //   return i;
            // });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleTypeChange(val, type) {
      if (type === "remove") {
        let removeIndex = this.filterType.findIndex((item) => item === val);
        if (removeIndex > -1) {
          this.filterType.splice(removeIndex, 1);
        }
      }
      this.changeQueryParams(true);
    },
    handleIndustryChange(val, type) {
      if (type === "remove") {
        let removeIndex = this.filterClass.findIndex((item) => item === val);
        if (removeIndex > -1) {
          this.filterClass.splice(removeIndex, 1);
        }
      }
      this.changeQueryParams(true);
    },
    handleTimeChange() {
      if (this.filterTime !== 3) {
        this.filterTimeRange = [];
        this.changeQueryParams(true);
      }
    },
    datePickerChange() {
      if (this.filterTimeRange && this.filterTimeRange.length > 0) {
        this.filterTime = 3;
      } else {
        this.filterTimeRange = [];
        this.filterTime = null;
      }
      this.changeQueryParams(true);
    },
    handleTimeRemove() {
      this.filterTime = null;
      this.filterTimeRange = [];
      this.changeQueryParams(true);
    },
    handlePageChange() {
      this.changeQueryParams(true);
    },
    handleInstitutionSearch() {
      if (!this.filterInputInstitution) {
        this.$message.warning("请输入检索词");
        return;
      }
      this.filterInput = this.filterInputInstitution;

      this.changeQueryParams(true);
    },
    handleSortChange() {
      this.changeQueryParams(true);
    },
    handleCurrentPageChange(currentPage) {
      this.pageIndex = currentPage;
      this.changeQueryParams(false);
    },
    clearFilter() {
      this.filterType = [];
      this.filterClass = [];
      this.filterTime = null;
      this.filterTimeRange = [];
      this.searchSort = 0;
      this.filterInput = "";
      this.changeQueryParams(true);
    },
  },
  beforeDestroy() {
    document.documentElement.style.overflowY = "auto";
  },
};
</script>

<style lang="scss">
.el-image-viewer__wrapper {
  .el-image-viewer__mask {
    opacity: 0.9;
  }
  .el-image-viewer__canvas {
    .el-image-viewer__img {
      max-width: 70% !important;
      max-height: 70% !important;
    }
  }
}
.img-viewer-title {
  position: fixed;
  left: 10%;
  top: 25px;
  z-index: 9999;
  color: #fff;
  width: 80%;
  @media screen and (max-width: 768px) {
    width: 65%;
  }
}
.img-viewer-download {
  position: fixed;
  right: 40px;
  bottom: 50px;
  z-index: 9999;
}
.z-index-9999 {
  z-index: 9999 !important;
}
</style>
<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/search.scss";

.data-list {
  ::v-deep dl {
    cursor: unset;
    dt {
      a {
        max-width: 355px;
      }
    }
    // 图片加载中效果
    .pic {
      cursor: pointer;

      .el-image__placeholder {
        background: url("~@/assets/images/loading.gif") no-repeat center;
        position: absolute;
        top: 0;
      }
    }
  }
}

.search-top-page ::v-deep {
  margin-left: 5px;

  .el-pagination__total:before {
    background-color: #c9e4ed;
  }

  .el-pager li {
    display: inline-block;
  }
  .el-pager li.active {
    margin-left: 5px !important;
  }
}
.search-page ::v-deep {
  .el-pager li {
    display: inline-block;
  }
  .el-pager li.active {
    margin-left: 5px !important;
  }
}

$searcherHeight: 95px;
$searcherInputHeight: 40px;
#searcher {
  height: $searcherHeight;
  > .wrapper {
    height: 100%;
  }
  .search-box {
    padding: 28px 50px 0 560px;
    text-align: center;
  }
  .search-data {
    display: none;
    margin-bottom: 20px;
    font-size: $fontSizeBig;
    line-height: 40px;
    text-align: center;
    span {
      padding: 0 5px;
      font-size: 1.2em;
      color: #fa3c17;
    }
  }
  .search-input {
    margin: 0 auto;
    &_select {
      width: 140px;
      margin-right: 2px;
      ::v-deep .el-input__inner {
        border-radius: $boxRadius !important;
      }
    }
    &_button {
      width: 150px;
      margin-left: 1px;
      color: #fff;
      font-size: $fontSizeBig;
      height: $searcherInputHeight;
      background-color: $colorMain;
      border-radius: 0 $boxRadius $boxRadius 0;
    }

    ::v-deep {
      .el-input-group__append,
      .el-input-group__prepend {
        border: 0;
        background-color: transparent;
      }
      .el-input-group__append {
        padding-left: 0;
      }
      .el-input-group__prepend {
        padding-right: 0;
      }
      .el-input__inner {
        height: $searcherInputHeight;
        line-height: $searcherInputHeight;
        background-color: #fff;
        border: 0;
        border-radius: $boxRadius 0 0 $boxRadius;
      }
    }
  }
  .search-hot {
    display: none;
    max-width: 700px;
    margin: 15px auto 0;
    color: $colorFontSub;
    line-height: 30px;
    text-align: center;
    @include clip;
    a {
      display: inline-block;
      max-width: 10em;
      vertical-align: top;
      @include clip;
      &:hover {
        color: $colorMain;
      }
      + a {
        margin-left: 10px;
      }
    }
  }
}

::v-deep .picshow {
  .el-image {
    text-align: center;
    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
    }
  }
}

.el-col-18 {
  width: calc(100% - 340px - 40px);
}
.el-col-6 {
  width: 340px;
}
.report-picshow {
  ::v-deep {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__headerbtn {
      top: 0;
      right: -50px;
      width: 50px;
      height: 50px;
      line-height: 55px;

      background-color: rgba(0, 0, 0, 0.5);
      i {
        font-size: 24px;
        color: #fff;
      }
    }
    .el-dialog__body {
      padding: 25px;
    }
  }
  .intro {
    position: relative;
    margin-bottom: 30px;
    padding: 15px 15px 15px 160px;
    font-size: 13px;
    line-height: 24px;
    color: #252b3a;
    background-color: #e7fafe;
    z-index: 1;
    &:after {
      position: absolute;
      top: -10px;
      right: -10px;
      bottom: -10px;
      left: -10px;
      background: url(~@/assets/images/picshow-arrow1.png) no-repeat left top,
        url(~@/assets/images/picshow-arrow2.png) no-repeat right top,
        url(~@/assets/images/picshow-arrow3.png) no-repeat right bottom,
        url(~@/assets/images/picshow-arrow4.png) no-repeat left bottom;
      z-index: -1;
      content: "";
    }
    .logo {
      position: absolute;
      left: 15px;
      top: 15px;
      height: 46px;
    }
  }
  .picshow {
    ::v-deep {
      .el-carousel__container {
        height: 457px;
      }
      .el-carousel__arrow {
        margin-top: 26px;
      }
      .el-carousel__arrow--left {
        left: 0;
      }
      .el-carousel__arrow--right {
        right: 0;
      }
    }
    label {
      display: block;
      margin-bottom: 20px;
      font-size: 24px;
      line-height: 32px;
      @include clips(1);
    }
    .el-image {
      width: 100%;
      height: 400px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .report-info {
    padding-top: 10px;
    .title {
      margin-bottom: 10px;
      font-size: 18px;
      line-height: 32px;
    }
    .info {
      margin-bottom: 15px;
      font-size: $fontSizeSmall;
      color: $colorFontSub;
      > span {
        img {
          height: 16px;
          margin-right: 3px;
          vertical-align: -3px;
        }
        + span {
          margin-left: 40px;
        }
      }
      .o {
        span + span {
          margin-left: 25px;
        }
      }
    }
    .bottom {
      display: flex;
      margin-bottom: -15px;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-top: 1px solid #d3d5d8;
      .type {
        height: 32px;
        margin-right: 15px;
        padding: 0 15px;
        line-height: 30px;
        font-size: 14px;
        background-color: #fde1dc;
        border: 1px solid #fdc4b9;
        border-radius: 20px;
        white-space: nowrap;
      }
      .el-button {
        height: 30px;
        padding: 0px 15px;
        font-size: $fontSize;
        line-height: 30px;
        border-radius: 20px;
        vertical-align: top;
        img {
          margin-right: 5px;
          vertical-align: -3px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .el-col-18 {
    width: 100%;
  }
  .el-col-6 {
    width: 100%;
  }
  .report-picshow {
    ::v-deep {
      .el-dialog__headerbtn {
        top: -50px;
        right: 0;
      }
    }
    .intro {
      padding-left: 15px;
      display: none;

      .logo {
        position: static;
        float: left;
        margin-right: 10px;
      }
    }
    .picshow {
      ::v-deep {
        .el-carousel__container {
          height: calc(50vw + 64px);
        }
      }
      label {
        height: 44px;
        font-size: 16px;
        line-height: 22px;
        @include clips(2);
      }
      .el-image {
        height: 50vw;
      }
    }
    .report-info {
      .title {
        font-size: 14px;
        line-height: 22px;
      }
      .info {
        display: flex;
        justify-content: space-between;
        > span {
          max-width: 33%;
          @include clip;
          img {
            display: none;
          }
          + span {
            margin-left: 0;
          }
        }
        .o {
          span + span {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
